import React from 'react';
import {browserHistory, IndexRoute, Route, Router} from 'react-router';
import AppComponent from '../AppComponent';
import LegacyWrapper from 'components/LegacyWrapper';
import CallCardPage from 'components/calls/CallCardPage';
import {authCheck, dashboardRedirectOnChange, embedNavCheck} from 'components/routes/Router.utils';
import {dashV2Route} from 'components/routes/DashboardRoutes';
import {authRoutes} from 'components/routes/AuthRoutes';
import {miscRoutes} from 'components/routes/MiscRoutes';
import {inboxRoute} from 'components/routes/InboxRoute';
import {adminRoute} from 'components/routes/AdminRoute';
import {repProfileRoutes} from 'components/RepProfileRoutes';
import {callsRoute} from 'components/routes/CallsRoute';
import {libraryRoute} from 'components/routes/LibraryRoute';
import {unauthorizedRoutes} from 'components/routes/UnauthorizedRoutes';
import {embedRoutes} from 'components/routes/EmbedRoutes';
import AuthWrapper from 'components/AuthWrapper';
import {homepageRoutes} from 'components/routes/HomepageRoutes';

export const appRoutes = (
  <Router history={browserHistory}>
    <Route path="/" component={AppComponent}>
      {authRoutes}
      {miscRoutes}
      <Route component={AuthWrapper} onChange={embedNavCheck} onEnter={authCheck}>
        {embedRoutes}
        {/* Non-embedded routes */}
        <Route component={LegacyWrapper}>
          <IndexRoute onEnter={dashboardRedirectOnChange} />
          {homepageRoutes}
          {dashV2Route}
          {repProfileRoutes}
          {callsRoute}
          {inboxRoute}
          {libraryRoute}
          {adminRoute}
          <Route path="call/:callId" component={CallCardPage} />
        </Route>
      </Route>
      {unauthorizedRoutes}
    </Route>
  </Router>
);
